var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"a-title a-title--white"},[_vm._v("Szanowny Kliencie")]),_c('p',{staticClass:"a-text a-text--white"},[_vm._v(" Aktualnie nie posiadasz pakietu pozwalającego na przeglądanie zasobów Agriibazy. ")])])
}]

export { render, staticRenderFns }